import FJTextToFullVideoStartContainer from '../FJTextToFullVideoStart/FJTextToFullVideoStartContainer';
import FJTextToVideoScriptEditContainer from '../FJTextToVideoScriptEdit/FJTextToVideoScriptEditContainer';
import FJVideoSettingsContainer from '../FJVideoSettings/FJVideoSettingsContainer';
import PropTypes from 'prop-types';
import FJConstant from '../../../constants/FJConstant';
import FJTextToVideoScriptPasteContainer from '../FJTextToVideoScriptPaste/FJTextToVideoScriptPasteContainer';
import FJDisplayPanel from '../FJDisplayPanel/FJDisplayPanel';

const FJTextToFullVideo = props => {
    const { textToVideoStep } = props;

    return (
        <>
            <FJDisplayPanel active={textToVideoStep === FJConstant.STEP_TYPE_HOME}>
                <FJTextToFullVideoStartContainer />
            </FJDisplayPanel>
            <FJDisplayPanel active={textToVideoStep === FJConstant.STEP_TYPE_SCRIPTS_PASTE}>
                <FJTextToVideoScriptPasteContainer />
            </FJDisplayPanel>
            <FJDisplayPanel active={textToVideoStep === FJConstant.STEP_TYPE_SCRIPTS_EDIT}>
                <FJTextToVideoScriptEditContainer />
            </FJDisplayPanel>
            <FJDisplayPanel active={textToVideoStep === FJConstant.STEP_TYPE_VIDEO_SETTINGS}>
                <FJVideoSettingsContainer />
            </FJDisplayPanel>
        </>
    );
};

FJTextToFullVideo.propTypes = {
    textToVideoStep: PropTypes.string,
};

export default FJTextToFullVideo;
